import { baseApi } from '@shared/api/baseApi'
import type { UserProfile } from '../types'

export const getProfile = async (): Promise<UserProfile> => {
  const { data } = await baseApi.get<UserProfile>('/api/user/profile')
  return data
}

export const updateProfileName = async (name: string): Promise<UserProfile> => {
  const { data } = await baseApi.patch<UserProfile>('/api/user/profile', { name })
  return data
}
